import { publishDomainEvent } from '@/services/events/eventPublisher.service';
import type { InventoryMovement } from '@/services/inventoryMovements/types';

export function publishInventoryTransfer(
  movement: InventoryMovement,
): Promise<void> {
  return publishDomainEvent('inventory.transfer', {
    movementId: movement.id,
    inventoryItemId: movement.inventoryItemId,
    fromLocationId: movement.fromLocationId ?? '',
    toLocationId: movement.toLocationId ?? '',
  });
}

export function publishInventoryAdjustment(
  movement: InventoryMovement,
): Promise<void> {
  return publishDomainEvent('inventory.adjustment', {
    movementId: movement.id,
    inventoryItemId: movement.inventoryItemId,
    quantity: movement.quantity ?? 0,
  });
}

export function publishInventoryDiscrepancy(
  movement: InventoryMovement,
): Promise<void> {
  return publishDomainEvent('inventory.discrepancy', {
    movementId: movement.id,
    inventoryItemId: movement.inventoryItemId,
    notes: movement.notes,
  });
}

export function publishInventoryMovementCritical(
  movement: InventoryMovement,
): Promise<void> {
  return publishDomainEvent('inventory.movement.critical', {
    movementId: movement.id,
    inventoryItemId: movement.inventoryItemId,
    type: movement.type,
  });
}
